import React from "react";
import Page from "../components/Page";

// Import
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { usePullEntry } from "../hooks/usePullEntry";

// Import for Displays

import LoadingPage from "./LoadingPage";

function ResourcePage() {
  const { data } = useSelector((state) => state.cms);

  // Access data for this specific entry.
  let { id } = useParams();
  const collectionSlug = "resources";
  const entryData = usePullEntry(collectionSlug, data, id);

  // Only load if data has returned.
  if (!entryData) return <LoadingPage />;
  return (
    <Page data-wf-page="635172d19055f69316afdc2c" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="section wf-section">
        <div className="containercentered w-container">
          <h1>{entryData.title}</h1>
          <div className="embedpdf w-embed w-iframe">
            <iframe title="pdf" height="100%" width="100%" src={entryData.pdf.data && entryData.pdf.data.attributes.url} />
          </div>
        </div>
      </div>
    </Page>
  );
}

export default ResourcePage;
